import React from "react";
import { Box, Tooltip as ToolTip, useMediaQuery } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import {
  Exposure as ExposureIcon,
  ZoomIn as ZoomInIcon,
  ZoomOut as ZoomOutIcon,
  ArrowCircleLeft as ArrowCircleLeftIcon,
  ArrowCircleRight as ArrowCircleRightIcon,
  Restore,
} from "@mui/icons-material";
import { useTheme } from "@emotion/react";


export const chartZoomOptions = {
  pan: {
    enabled: true,
    mode: "x",
  },
  zoom: {
    wheel: {
      enabled: true,
    },
    pinch: {
      enabled: true,
    },
    mode: "x",
  },
};

export const createChartRefFunctions = (chartRef) => {
  return {
    onResetZoom: () => {
      chartRef.current.resetZoom();
    },
    onZoomPluse: () => {
      chartRef.current.zoom(1.1);
    },
    onZoomMinus: () => {
      chartRef.current.zoom(0.9);
    },
    onPanPluse: () => {
      chartRef.current.pan({ x: 100 }, undefined, "default");
    },
    onPanMinus: () => {
      chartRef.current.pan({ x: -100 }, undefined, "default");
    },
  };
};

const ZoomControls = ({
  onResetZoom,
  onZoomPluse,
  onZoomMinus,
  onPanPluse,
  onPanMinus,
}) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up('md'));

  return (
    <Box
      id="button-PSD-chart"
      style={{
        display: "flex",
        position: "relative",
        zIndex: 1
      }}
    >
      <ToolTip title="Reset Zoom">
        <IconButton size="large" onClick={onResetZoom}>
          <Restore sx={{ color: "text.secondary" }} />
        </IconButton>
      </ToolTip>
      {isLargeScreen &&
        <>
          <ToolTip title="Zoom +">
            <IconButton size="large" onClick={onZoomPluse}>
              <ZoomInIcon sx={{ color: "text.secondary" }} />
            </IconButton>
          </ToolTip>
          <ToolTip title="Zoom -">
            <IconButton size="large" onClick={onZoomMinus}>
              <ZoomOutIcon sx={{ color: "text.secondary" }} />
            </IconButton>
          </ToolTip>
        </>
      }
      <ToolTip title="Left">
        <IconButton size="large" onClick={onPanPluse}>
          <ArrowCircleLeftIcon sx={{ color: "text.secondary" }} />
        </IconButton>
      </ToolTip>
      <ToolTip title="Right">
        <IconButton size="large" onClick={onPanMinus}>
          <ArrowCircleRightIcon sx={{ color: "text.secondary" }} />
        </IconButton>
      </ToolTip>
    </Box>
  );
};

export default ZoomControls;
